const styles = {
  container: {
    padding: '0 1.5rem',
    margin: '0 auto',
    maxWidth: '100%',
    height: '100vh',
    overflow: 'auto',
  },
  spaceBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  formContainer: {
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

export default styles;
